import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'utils/modifiedTranslation';
import Grid from '@material-ui/core/Grid';
import TextInput from 'components/TextInput';
import { getNumberInputParameters } from 'modules/questionnaire/helpers';
import { useNumberInputValidation } from 'modules/questionnaire/useNumberInputValidation';
import QuestionTitle from './QuestionTitle';
import QuestionSubTitle from './QuestionSubTitle';
import QuestionOptionsContainer from './QuestionOptionsContainer';

const NumberInput = ({ question, onChange, value = '' }) => {
  const { t } = useTranslation();
  const defaultInputLabel = 'questionnaire.questions.global.default.placeholder.typing_here';
  const {
    id, title, subtitle, numberType, label = defaultInputLabel, instruction,
  } = question;
  const {
    step, unit, min, max,
  } = getNumberInputParameters(numberType);

  const validate = useNumberInputValidation({ max, min });

  const handleChange = (nextValue) => {
    if (validate(nextValue).isValid) {
      onChange(nextValue);
    }
  };

  return (
    <Grid key={id}>
      <QuestionTitle label={title} />

      {subtitle && <QuestionSubTitle label={subtitle} />}
      <QuestionOptionsContainer>
        <TextInput
          placeholder={t(label)}
          value={value}
          step={step}
          unit={unit}
          helperText={instruction}
          onChange={handleChange}
          min={min}
          max={max}
        />
      </QuestionOptionsContainer>
    </Grid>
  );
};

NumberInput.propTypes = {
  /**
   * Question object with title, subtitles, etc
   */
  question: PropTypes.object.isRequired,
  /**
   * Input placeholder
   */
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default NumberInput;
